module.exports = __webpack_public_path__ + "static/img/96063A_2_3_R_2020220_LC.58fc358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96063A_2_3_R_2020220_LC.png
// module id = P5Xr
// module chunks = 0